/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Spin, Checkbox, Radio } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import {
  Globe,
  Briefcase,
  MapPin,
  Home,
  Building2,
  Map,
  Flag,
  Hash,
  Mail,
  Phone,
  User,
  Users,
  Calendar,
  CreditCard,
  FileText,
  Building,
  CircleUser,
  UserCheck,
  AtSign,
  Landmark,
  AlignLeft,
  DollarSign,
  BadgePercent,
  BadgeCheck,
} from 'lucide-react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import useGetResponse from '../../../utils/useGetResponse';
import { InputInterface } from '../../../utils/forms/FormInterface';
import { getIncomingPayload } from '../../../utils/getIncomingPayload';
import { getOutgoingPayload } from '../../../utils/getOutgoingPayload';
import { getAllAccordions } from '../../../utils/forms/formFunctions';
import { formatDate, updateDatamodel, updateFormFields } from '../../../utils/functions';

import { toastError, toastSuccess } from '../../../service/Toast';
import callApi from '../../../Api/config';

import CheckboxGroup from '../../../components/CheckboxGroup';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';
import Email from '../../../components/Email';
import PinCode from '../../../components/PinCode';
import SelectInput from '../../../components/SelectInput';
import MultiSelectInput from '../../../components/MultiSelectInput';
import NumberInput from '../../../components/NumberInput';
import TimeSlotInput from '../../../components/TimeSlotInput';
import MultipleTextInput from '../../../components/MultipleTextInput';
import MultipleTwinInput from '../../../components/MultipleTwinInput';
import DynamicPackagesInput from '../../../components/DynamicPackagesInput';
import FileInput from '../../../components/FileInput';
import DateInput from '../../../components/DateInput';
import OptionalSelectInput from '../../../components/OptionalSingleSelect';
import TextEditor from '../../../components/TextEditor';
import DrawerInput from '../../../components/DrawerInput';
// import ServiceProcess from '../../../components/ServiceProcess';

import { errorMsg, failedMsg } from '../../../constants/messages';
import {
  CATEGORIES_ENTITY,
  ORDER_LIST_ENTITY,
  SUBCATEGORIES_ENTITY,
  DEFECT_TYPES_ENTITY,
  VARIANTS_ENTITY,
  AVAILABLE_DELIVERY_PARTNERS,
  COMPLAINTS_ENTITY,
  MANAGER_TECHNICIAN_ENTITY,
  ALL_TECHNICIAN_ENTITY,
  ALL_MANAGERS_ENTITY,
  ASSETS_ENTITY,
  LOCATIONS_ENTITY,
  LOCATION_TYPES_ENTITY,
  APPLICATION_FORM_SERVICES,
  APPLICATION_FORM_PARAMETERS,
  APPLICATION_FORM_QUESTIONS,
  APPLICATION_FORM_PACKAGE_PLANS,
  APPLICATION_FORM_PACKAGE_FEATURES,
  APPLICATION_FORM_PACKAGE_DOCUMENTS,
  APPLICATION_FORM_PACKAGES,
  APPLICATION_FORM_PACKAGE_SERVICE_ATTRIBUTES,
  SERVICE_PROCESS_STEPS,
  SERVICE_PROCESS_DETAILS,
  SERVICE_PROCESS_SUBTITLE,
  FORMS_STEPS,
  FORMS,
  STORE_VARIANT_PRICES_ENTITY,
  STORES_ENTITY,
  STORE_SUBCATEGORY_INVENTORIES_ENTITY,
  STORE_ADDONS_ENTITY,
  ADDONS_ENTITY,
  BULK_ADDONS_ENTITY,
  STORE_BULK_ADDONS_ENTITY,
  STORE_INVENTORIES_ENTITY,
  SUBCATEGORY_INVENTORIES_ENTITY,
  PHOTO_ORDER_APPLICATION,
  DOCUMITRA_ORDER_APPLICATION,
  PARTNER_ORDERS,
  STEPS_QUESTIONS,
  CONDITIONS_PAGE,
  TERMS_PAGE,
  SERVICE_BASED_FAQ,
  SERVICE_PAGE_FAQ,
  TIME_LINE_HEADING,
  TIME_LINE_BODY,
  COUNTRY,
  SERVICE_TIMELINE,
  USERS_ENTITY,
  ORDER_USER,
  PACKAGE_TIMELINE,
  PACKAGE_PROCESS_STEPS,
  PACKAGE_PROCESS,
  COUNTRY_CODE,
  CONTACT_FORM,
  BECOME_PARTNER_INFO,
  DOCUMITRA_PARTNERS,
  RELATED_ARTICLE,
  NEWS_ARTICLE_ENTITY,
  HOMEPAGE_ARTICLE,
  SERVICE_CARDS_MANAGEMENT,
  HOMEPAGE_SERVICE_CATEGORY_ENTITY,
  HEADER_SERVICES_ENTITY,
} from '../../../constants/EntityName';

import '../entity.scss';
import './style.scss';
import './userForm.scss';
import TextArea from '../../../components/TextArea';
import DynamicSelectInput from '../../../components/DynamicSelectInput';
import { acceptableImageFormat } from '../../../constants/FilterDataValues';
import MultipleTwinInputforValidation from '../../../components/MultipleTwinInputforValidation';
import DynamicCheckboxInput from '../../../components/DynamicCheckboxInput';
import FormWithQuestions from '../../../components/FormWithQuestions';
import DynamicShowKeys from '../../../components/DynamicShowKey';
import PackagePlanSelection from '../../../components/PackagePlanSelection/PackagePlanSelection';
import ReviewDocumitraOrder from '../../../components/ReviewDocumitraOrder';
import ReviewPhotoOrder from '../../../components/ReviewPhotoOrder';
import ReviewPartnerOrder from '../../../components/ReviewPartnerOrder';
import ReviewPartnerOrderMember from '../../../components/ReviewPartnerOrderMember';
import TimelineTable from '../../../components/TimelineTable';
import InformtionNote from '../../../components/InformtionNote';
import DynamicCountrySelect from '../../../components/DynamicCountrySelect';
import { RemoveRolePermission } from '../../../constants/AppConstant';
import { getRole } from '../../../service/CookieManager';
import ServiceAttributeSelection from '../../../components/ServiceAttributeSelection';
import PackageProcess from '../../../components/PackageProcess';
import RefferalUserCard from '../../../components/RefferalUserCard';
import RolePermissions from '../../../components/RolePermissions';
import ConfirmationModal from '../../../components/ConfirmationModal';
import AdminPasswordModal from '../../../components/AdminPasswordModal';
import UserFormSidebar from '../../../components/UserFormSidebar';
import QueryDetailsCard from '../../../components/QueryDetailsCard';
import { InvertFillButton } from '../../../components/InvertFillButton';
import HorizontalTabNavigation, {
  HorizontalTabPanel,
} from '../../../components/HorizontalTabNavigation/HorizontalTabNavigation';

export enum UpdateRequestType {
  Put = 'PUT',
  Patch = 'PATCH',
  Post = 'POST',
}

interface AbstractFormProps {
  headerName: string;
  entityName: string;
  nestedEntityName?: string;
  formTemplate: Array<InputInterface>;
  payloadProcessor?: (arg: any, arg2: any, arg3?: any) => any;
  additionalEntityName?: string | { name: string; getAllResponse?: boolean }[];
  entityId?: string;
  isCreateMode?: boolean;
  disabledButton?: { delete?: boolean; update?: boolean; cancel?: boolean };
  hiddenButtons?: { delete?: boolean; update?: boolean; cancel?: boolean; save?: boolean };
  formDefaultPayload?: any;
  onSuccessfulUpdate?: (id?: string, newId?: string) => void;
  formHeader?: string | undefined;
  setDrawerVisible?: (props: boolean) => void;
  showDeleteDraft?: boolean;
  table?: React.ReactNode;
  closeTab?: (arg0: string, agr2: boolean) => void;
  updateRequired?: boolean;
  extraPayloadData?: any;
  updateRequestType?: UpdateRequestType;
  apiEndPoint?: string;
  apiMethod?: string;
  additionalButtons?: any[];
  hideCron?: boolean;
  hideMaxAmount?: boolean;
  maxDiscount?: boolean;
  /** When provided, this ref is populated with the form's submit function so a
   *  parent component can trigger submission from outside (e.g. after external content). */
  externalSubmitRef?: React.MutableRefObject<(() => void) | null>;
  /** Optional third section rendered beside the Documitra Partner form sections. */
  partnerAdditionalTab?: React.ReactNode;
  /** Optional "Agent Payment Ledger" tab rendered beside the partner form tabs. */
  partnerPaymentLedgerTab?: React.ReactNode;
}

const AbstractForm = (props: AbstractFormProps) => {
  const {
    entityName,
    isCreateMode,
    formTemplate: initialFormTemplate,
    updateRequired,
    additionalEntityName: incomingAdditionalEntityName,
    extraPayloadData,
    nestedEntityName,
    updateRequestType = UpdateRequestType.Patch,
    additionalButtons,
    hiddenButtons,
    externalSubmitRef,
  } = props;

  const isAgentUsersPage = !!(props.partnerAdditionalTab && props.partnerPaymentLedgerTab);

  // For Header Services, use props.formDefaultPayload directly if available, otherwise use state
  const [defaultFormData, setDefaultFormData] = useState(props.formDefaultPayload);
  const [incomingFormData, setIncomingFormData] = useState<any>();
  const [formDetails, setFormDetails] = useState<any>();
  const [formTemplate, setFormTemplate] = useState(initialFormTemplate);
  const [additionalEntityName, setAdditionalEntityName] = useState(incomingAdditionalEntityName);
  const additionalData = useGetResponse(additionalEntityName);
  const [loading, setLoading] = useState(false);
  const [dynamicValidation, setDynamicValidation] = useState();
  const [first, setfirst] = useState();

  const [parameterData, setParameterData] = useState<any>({});
  const [userFormValues, setUserFormValues] = useState<any>({});

  const statusRef = useRef<string>();
  const [form] = Form.useForm();

  // Expose form.submit to parent via ref so buttons can live outside AbstractForm
  useEffect(() => {
    if (externalSubmitRef) {
      externalSubmitRef.current = () => form.submit();
    }
  }, [externalSubmitRef, form]);

  // Update form values when default payload changes (fixes issue with default values not showing on re-render)
  useEffect(() => {
    if (props.formDefaultPayload) {
      form.setFieldsValue(props.formDefaultPayload);
    }
  }, [props.formDefaultPayload, form]);

  const [openModal, setOpenModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [orderReviewPrimaryTab, setOrderReviewPrimaryTab] = useState<string | null>(null);
  console.log('formTemplate', form);

  // Update defaultFormData when formDefaultPayload changes (for Header Services)
  useEffect(() => {
    if (entityName === HEADER_SERVICES_ENTITY && props.formDefaultPayload) {
      const hasTransformedData =
        props.formDefaultPayload.serviceName !== undefined ||
        Object.keys(props.formDefaultPayload).some(key => key.startsWith('package'));
      if (hasTransformedData) {
        console.log('Updating defaultFormData for Header Services:', props.formDefaultPayload);
        setDefaultFormData(props.formDefaultPayload);
        // Also update form values directly
        form.setFieldsValue(props.formDefaultPayload);
      }
    }
  }, [props.formDefaultPayload, entityName, form]);

  const currentUserRole: any = getRole();
  let rolePermission = RemoveRolePermission[currentUserRole];

  if (entityName === USERS_ENTITY && currentUserRole === 'Ops Manager') {
    rolePermission = {
      create: true,
      read: false,
      delete: true,
      update: true,
    };
  }

  /**
   * This useEffect is used to update the formTemplate file which is defined in the datamodels folder. It can be required in cases where the options for certain field are not known apriori and are obtained through API call
   */
  useEffect(() => {
    const updateFormTemplate = async () => {
      switch (entityName) {
        // case USERS_ENTITY: {
        //     const rolesOptions = additionalData?.[ROLES_ENTITY]?.data?.results;

        //     const check = rolesOptions;

        //     check &&
        //         setFormTemplate((formData: any) =>
        //             formData.map((dataModel: any) => {
        //                 if (dataModel.name === 'role') {
        //                     return {
        //                         ...dataModel,
        //                         fieldType: {
        //                             ...dataModel.fieldType,
        //                             options: rolesOptions.map((item: { id: string; name: string }) => ({
        //                                 value: item.id,
        //                                 name: item.name,
        //                             })),
        //                         },
        //                     };
        //                 }

        //                 return dataModel;
        //             }),
        //         );

        //     break;
        // }

        case APPLICATION_FORM_PACKAGE_PLANS: {
          const featuresList = additionalData?.[APPLICATION_FORM_PACKAGE_FEATURES]?.data;
          const documentsList = additionalData?.[APPLICATION_FORM_PACKAGE_DOCUMENTS]?.data;

          const check = documentsList && featuresList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'documents') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: documentsList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }
                if (dataModel.name === 'features') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: featuresList?.map((item: { id: string; description: string }) => ({
                        value: item.id,
                        name: item.description,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case SERVICE_CARDS_MANAGEMENT: {
          const categories = additionalData?.[HOMEPAGE_SERVICE_CATEGORY_ENTITY]?.data?.results;
          const check = categories;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'heading') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: categories?.map((item: { id: number; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
        case PACKAGE_PROCESS_STEPS: {
          const packageList = additionalData?.[APPLICATION_FORM_PACKAGES]?.data;

          const check = packageList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'packages') {
                  return {
                    ...dataModel,
                    // readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: packageList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case USERS_ENTITY: {
          const countryCodeList = additionalData?.[COUNTRY_CODE]?.data;

          const check = countryCodeList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'createdAt') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryCodeList?.map((item: { code: string; name: string }) => ({
                        value: item.code,
                        name: `${item.code} (${item.name})`,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case DOCUMITRA_PARTNERS: {
          const countryList = additionalData?.[COUNTRY]?.data;
          const check = countryList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'originCountry' || dataModel.name === 'addressCountry') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      name: 'select',
                      options: countryList.map((country: string) => ({
                        value: country,
                        name: country,
                      })),
                    },
                  };
                }
                return dataModel;
              })
            );
          break;
        }

        case PACKAGE_TIMELINE: {
          const packageList = additionalData?.[APPLICATION_FORM_PACKAGES]?.data;

          const check = packageList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'packages') {
                  return {
                    ...dataModel,
                    // readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: packageList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
        case PACKAGE_PROCESS: {
          const packageList = additionalData?.[APPLICATION_FORM_PACKAGES]?.data;

          const check = packageList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'packages') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: packageList?.map(
                        (item: { id: string; name: string }, index: number) => ({
                          value: item.id,
                          name: `${index + 1}. ${item.name}`,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case APPLICATION_FORM_PACKAGES: {
          const servicesList = additionalData?.[APPLICATION_FORM_SERVICES]?.data?.results;
          const servicesAttributesList =
            additionalData?.[APPLICATION_FORM_PACKAGE_SERVICE_ATTRIBUTES]?.data;
          const featuresList = additionalData?.[APPLICATION_FORM_PACKAGE_FEATURES]?.data;
          const documentsList = additionalData?.[APPLICATION_FORM_PACKAGE_DOCUMENTS]?.data;
          const countryList = additionalData?.[COUNTRY]?.data;

          const check = servicesList && servicesAttributesList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'serviceAttributes') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesAttributesList?.map(
                        (item: { id: string; name: string }) => ({
                          value: item.id,
                          name: item.name,
                        })
                      ),
                    },
                  };
                }
                if (dataModel.name === 'service') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesList?.map(
                        (item: { id: string; name: string; parameters: any }) => ({
                          value: item.id,
                          name: item.name,
                          parameters: item.parameters,
                        })
                      ),
                    },
                  };
                }

                if (dataModel.name === 'citizenship') {
                  return {
                    ...dataModel,
                    isAccordian: isCreateMode ? false : parameterData.citizenship,
                    readonly: false,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryList?.map((item: any) => ({
                        name: item,
                        value: item,
                      })),
                    },
                  };
                }
                if (dataModel.name === 'destination') {
                  return {
                    ...dataModel,
                    isAccordian: isCreateMode ? false : parameterData.destination,
                    readonly: false,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryList?.map((item: any) => ({
                        name: item,
                        value: item,
                      })),
                    },
                  };
                }
                if (dataModel.name === 'applyingFrom') {
                  return {
                    ...dataModel,
                    isAccordian: isCreateMode ? false : parameterData.applyingFrom,
                    readonly: false,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryList?.map((item: any) => ({
                        name: item,
                        value: item,
                      })),
                    },
                  };
                }

                if (dataModel.name === 'serviceAttributes') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case STEPS_QUESTIONS: {
          const questionsList = additionalData?.[APPLICATION_FORM_QUESTIONS]?.data;

          const check = questionsList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'question') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: questionsList?.map(
                        (item: { id: string; label: string; inputType: string }) => ({
                          value: item.id,
                          name: `${item.label}-${item.inputType}`,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case PHOTO_ORDER_APPLICATION: {
          const photoOrders = additionalData?.[PHOTO_ORDER_APPLICATION]?.data?.results;
          const check = photoOrders;

          check && setFormTemplate((formData: any) => formData.map((dataModel: any) => dataModel));

          break;
        }

        case DOCUMITRA_ORDER_APPLICATION: {
          const documentOrders = additionalData?.[DOCUMITRA_ORDER_APPLICATION]?.data?.results;
          const check = documentOrders;

          check && setFormTemplate((formData: any) => formData.map((dataModel: any) => dataModel));

          break;
        }

        case FORMS: {
          const packageList = additionalData?.[APPLICATION_FORM_PACKAGES]?.data;

          const check = packageList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'package') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: packageList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: `${item.id} - ${item.name}`,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case APPLICATION_FORM_SERVICES: {
          const countryList = additionalData?.[COUNTRY]?.data;

          const countryData = countryList?.map((countryName: string, index: number) => ({
            id: index + 1,
            value: countryName,
            name: countryName,
          }));

          const check = countryData;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'countries') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryData?.map((item: { id: string; name: string }) => ({
                        value: item.name,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case SERVICE_PROCESS_DETAILS:
        case SERVICE_PROCESS_STEPS: {
          const servicesList = additionalData?.[APPLICATION_FORM_SERVICES]?.data?.results;

          const check = servicesList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'service') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
        case SERVICE_TIMELINE: {
          const servicesList = additionalData?.[APPLICATION_FORM_SERVICES]?.data?.results;

          const check = servicesList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'service') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesList?.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case SERVICE_PROCESS_SUBTITLE: {
          const processList = additionalData?.[SERVICE_PROCESS_DETAILS]?.data?.results;

          const check = processList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'title') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: processList?.map((item: { id: string; heading: string }) => ({
                        value: item.id,
                        name: item.heading,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case DEFECT_TYPES_ENTITY: {
          const subCategoryOptions = additionalData?.[SUBCATEGORIES_ENTITY]?.data?.results;

          const check = subCategoryOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'subcategory') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: subCategoryOptions.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
        case LOCATIONS_ENTITY:
        case ASSETS_ENTITY: {
          const locationTypesOptions = additionalData?.[LOCATION_TYPES_ENTITY]?.data?.results;

          const check = locationTypesOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'locationType') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: locationTypesOptions.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case TIME_LINE_HEADING:
        case SERVICE_BASED_FAQ: {
          const servicesOptions = additionalData?.[APPLICATION_FORM_SERVICES]?.data?.results;

          const check = servicesOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'service') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesOptions.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case SERVICE_PAGE_FAQ: {
          const categories = additionalData?.[HOMEPAGE_SERVICE_CATEGORY_ENTITY]?.data?.results;
          const check = categories;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'serviceCategory') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: categories.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case TIME_LINE_BODY: {
          const timeLineHeadingOptions = additionalData?.[TIME_LINE_HEADING]?.data?.results;

          const check = timeLineHeadingOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'timeLine') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: timeLineHeadingOptions.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case COMPLAINTS_ENTITY: {
          const defectTypeOptions = additionalData?.[DEFECT_TYPES_ENTITY]?.data?.results;

          const check = defectTypeOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'defectType') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: defectTypeOptions.map((item: { id: string; name: string }) => ({
                        value: item.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case CONDITIONS_PAGE: {
          const termsOptions = additionalData?.[TERMS_PAGE]?.data?.results;

          const check = termsOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'term') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: termsOptions.map(
                        (item: { id: string; name: string; asset: any }) => ({
                          value: item.id,
                          name: `${item.name}`,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case SUBCATEGORIES_ENTITY: {
          const categoriesOptions = additionalData?.[CATEGORIES_ENTITY]?.data?.results;

          const check = categoriesOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'category') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: categoriesOptions.map(
                        (item: { id: string; name: string; asset: any }) => ({
                          value: item.id,
                          name: `${item.name} - ${item.asset?.name}`,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case CATEGORIES_ENTITY: {
          const assetsOptions = additionalData?.[ASSETS_ENTITY]?.data?.results;
          const managersOptions = additionalData?.[ALL_MANAGERS_ENTITY]?.data?.results;

          const check = assetsOptions && managersOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'asset') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: assetsOptions.map(
                        (item: { id: string; name: string; locationType: any }) => ({
                          value: item?.id,
                          name: `${item.name} - ${item?.locationType.name}`,
                        })
                      ),
                    },
                  };
                }

                if (dataModel.name === 'manager') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: managersOptions.map((item: { id: string; name: string }) => ({
                        value: item?.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case MANAGER_TECHNICIAN_ENTITY: {
          let allTechnicianOptions = additionalData?.[ALL_TECHNICIAN_ENTITY]?.data?.results;
          const managersOptions = additionalData?.[ALL_MANAGERS_ENTITY]?.data?.results;

          if (incomingFormData?.results?.technicians.length && allTechnicianOptions?.length) {
            allTechnicianOptions = [
              ...incomingFormData.results.technicians,
              ...allTechnicianOptions,
            ];
          }

          const check = allTechnicianOptions && managersOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'technicians') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel?.fieldType,
                      options: allTechnicianOptions.map(
                        (option: { id: string; name: string; mobile: string }) => ({
                          value: option.id,
                          name: `${option.name}-${option.mobile}`,
                        })
                      ),
                    },
                  };
                }

                if (dataModel.name === 'manager') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: managersOptions.map((item: { id: string; name: string }) => ({
                        value: item?.id,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
        case RELATED_ARTICLE: {
          const servicesList = additionalData?.[APPLICATION_FORM_SERVICES]?.data?.results;

          const check = servicesList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'linkedService') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: servicesList?.map((item: { id: string; name: string }) => ({
                        value: item.name,
                        name: item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }
      }

      const entityNamesArray = entityName.split('/');
      const requiredEntityName = entityNamesArray[entityNamesArray.length - 1];
      const requiredEntityName2 = entityNamesArray[entityNamesArray.length - 2];

      switch (`/${requiredEntityName}`) {
        case STORE_INVENTORIES_ENTITY: {
          const inventoriesOptions =
            additionalData?.[
              `${STORES_ENTITY}/${requiredEntityName2}${SUBCATEGORY_INVENTORIES_ENTITY}`
            ]?.data?.results;

          const check = inventoriesOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'inventory') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: inventoriesOptions.map(
                        (inventory: {
                          id: string;
                          displayName: string;
                          optionDisplayName: string;
                        }) => ({
                          value: inventory.id,
                          name: `${inventory.displayName}-${inventory.optionDisplayName}`,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );
          break;
        }

        case STORE_ADDONS_ENTITY: {
          const addonOptions = additionalData?.[ADDONS_ENTITY]?.data?.results;

          const check = addonOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'addon') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: addonOptions.map((addon: { id: string; displayName: string }) => ({
                        value: addon.id,
                        name: addon.displayName,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );
          break;
        }

        case STORE_BULK_ADDONS_ENTITY: {
          const bulkAddonsOptions = additionalData?.[BULK_ADDONS_ENTITY]?.data?.results;

          const check = bulkAddonsOptions;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'bulkAddon') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: bulkAddonsOptions.map(
                        (bulkAddon: { id: string; displayName: string }) => ({
                          value: bulkAddon.id,
                          name: bulkAddon.displayName,
                        })
                      ),
                    },
                  };
                }

                if (dataModel.name === 'bulkAddons') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                  };
                }

                return dataModel;
              })
            );
          break;
        }

        // @ts-ignore - Fallthrough case is intentional (case is properly closed with break above)
        case STORE_VARIANT_PRICES_ENTITY: {
          const variants =
            additionalData?.[
              `${STORES_ENTITY}/${requiredEntityName2}${STORE_SUBCATEGORY_INVENTORIES_ENTITY}`
            ]?.data?.results;

          const {
            [`${STORES_ENTITY}/${requiredEntityName2}${STORE_SUBCATEGORY_INVENTORIES_ENTITY}`]:
              variantData,
            ...storeInventoriesData
          } = additionalData;
          const storeInventories =
            storeInventoriesData[Object.keys(storeInventoriesData)[0]]?.data?.results;

          const check = variants && storeInventories;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'variant') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: variants.map((inventory: { id: string; displayName: string }) => ({
                        value: inventory.id,
                        name: inventory.displayName,
                      })),
                    },
                  };
                }

                if (dataModel.name === 'storeInventory') {
                  return {
                    ...dataModel,
                    readonly: !isCreateMode,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: storeInventories.map(
                        (storeInventory: { id: number; name: string; option: any }) => ({
                          value: storeInventory.id,
                          name: storeInventory.name,
                        })
                      ),
                    },
                  };
                }

                return dataModel;
              })
            );
        }

        case DOCUMITRA_PARTNERS: {
          const countryCodeList = additionalData?.[COUNTRY_CODE]?.data;

          const check = countryCodeList;

          check &&
            setFormTemplate((formData: any) =>
              formData.map((dataModel: any) => {
                if (dataModel.name === 'countryCode') {
                  return {
                    ...dataModel,
                    fieldType: {
                      ...dataModel.fieldType,
                      options: countryCodeList?.map((item: { code: string; name: string }) => ({
                        value: item.code,
                        name: item.code + ' ' + item.name,
                      })),
                    },
                  };
                }

                return dataModel;
              })
            );

          break;
        }

        case NEWS_ARTICLE_ENTITY: {
          const rawNews =
            additionalData?.[NEWS_ARTICLE_ENTITY]?.data?.results ||
            additionalData?.[NEWS_ARTICLE_ENTITY]?.data ||
            [];
          const newsList = Array.isArray(rawNews) ? rawNews : [];

          // Load categories from DB table via API (source of truth)
          let dbCategoryOptions: { value: string; name: string }[] = [];
          try {
            const categoriesRes: any = await callApi('/news/categories', 'GET', null, {
              includeEmpty: true,
            });
            const categoriesPayload = categoriesRes?.data?.data || categoriesRes?.data || [];
            const categoryRows = Array.isArray(categoriesPayload) ? categoriesPayload : [];
            dbCategoryOptions = categoryRows
              .map((item: any) => String(item?.name || '').trim())
              .filter(Boolean)
              .map((name: string) => ({ value: name, name }));
          } catch (error) {
            console.error('Failed to load news categories from DB', error);
          }

          setFormTemplate((formData: any) =>
            formData.map((dataModel: any) => {
              if (dataModel.name === 'relatedNewsIds' && newsList.length > 0) {
                return {
                  ...dataModel,
                  fieldType: {
                    ...dataModel.fieldType,
                    options: newsList.map((item: any) => ({
                      value: String(item.id),
                      name: `${item.title} (${item.category || 'General'})`,
                    })),
                  },
                };
              }

              if (dataModel.name === 'category') {
                const seen = new Set<string>();
                const merged: { value: string; name: string }[] = [];

                [...dbCategoryOptions, ...(dataModel.fieldType?.options || [])].forEach(
                  (opt: any) => {
                    const name = String(opt?.value || opt?.name || '').trim();
                    if (!name) return;
                    const key = name.toLowerCase();
                    if (seen.has(key)) return;
                    seen.add(key);
                    merged.push({ value: name, name });
                  }
                );

                // Include categories present on articles but missing from table response
                newsList.forEach((item: any) => {
                  const name = String(item.category || '').trim();
                  if (!name) return;
                  const key = name.toLowerCase();
                  if (seen.has(key)) return;
                  seen.add(key);
                  merged.push({ value: name, name });
                });

                return {
                  ...dataModel,
                  fieldType: {
                    ...dataModel.fieldType,
                    allowCustom: true,
                    options: merged.length ? merged : [{ value: 'General', name: 'General' }],
                  },
                };
              }

              return dataModel;
            })
          );
          break;
        }
      }
    };

    void updateFormTemplate();
  }, [additionalData, entityName, isCreateMode, incomingFormData]);

  /**
   * this function fetches data from API for any specific course/roles etc and sets that as the form field values. This function is not called while creating a new course/role.
   * @param coursesWorkshopResponseId
   */

  const getApiData = async () => {
    // Skip API call for Header Services if formDefaultPayload is provided with valid transformed data
    if (entityName === HEADER_SERVICES_ENTITY && props.formDefaultPayload) {
      const hasTransformedData =
        props.formDefaultPayload.serviceName !== undefined &&
        props.formDefaultPayload.serviceName !== null &&
        (Object.keys(props.formDefaultPayload).some(key => key.startsWith('package')) ||
          props.formDefaultPayload.package1Name !== undefined);
      if (hasTransformedData) {
        console.log(
          'getApiData: Skipping API call for Header Services, formDefaultPayload already provided'
        );
        return;
      } else {
        console.log('getApiData: formDefaultPayload incomplete, proceeding with API call');
      }
    }

    setLoading(true);

    try {
      const entityData: any = await callApi(`${props.entityName}/${props.entityId}`, 'GET');

      if (!entityData) {
        toastError('Error fetching API data');
        return;
      }
      const { data } = entityData.data;

      const { applyingFrom, citizenship, destination } = data;

      setParameterData({ applyingFrom, citizenship, destination });

      if (!isCreateMode && entityName === USERS_ENTITY) {
        const formTemplateData = formTemplate.filter((item: any) => item.name !== 'password');
        setFormTemplate(formTemplateData);
      }

      // Make password readonly for existing Documitra Partners
      if (!isCreateMode && entityName === DOCUMITRA_PARTNERS) {
        setFormTemplate((formData: any) =>
          formData.map((dataModel: any) => {
            // Make password readonly when editing
            if (dataModel.name === 'password') {
              return {
                ...dataModel,
                readonly: true,
                required: false, // Make it not required when editing
              };
            }
            return dataModel;
          })
        );
      }

      if (entityName === CONTACT_FORM || entityName === BECOME_PARTNER_INFO) {
        entityData.data.data.createdAt = formatDate(entityData?.data?.data?.createdAt);
      }

      if (entityData?.status && entityData?.data) {
        setIncomingFormData(entityData?.data?.data);
        const data = getIncomingPayload(props.entityName, entityData?.data?.data);

        setFormDetails(entityData?.data?.data);

        const defaultObj: any = {};
        console.log('data', data);
        for (const key in props.formDefaultPayload) {
          if (key === 'startDate' || key === 'expiryDate' || key === 'endDate') {
            defaultObj[key] = data[key] && moment(data[key]);
          } else {
            defaultObj[key] = data[key] ?? [];
          }
        }

        if (entityName === VARIANTS_ENTITY) {
          form.setFieldsValue(data);
        } else if (entityName === HEADER_SERVICES_ENTITY && props.formDefaultPayload) {
          // For Header Services, use formDefaultPayload directly as it contains transformed data
          form.setFieldsValue(props.formDefaultPayload);
        } else {
          // For DOCUMITRA_PARTNERS, ensure status and countryCode are included even if not in formDefaultPayload
          if (entityName === DOCUMITRA_PARTNERS) {
            if (data.status) {
              defaultObj.status = data.status;
            }
            if (data.countryCode) {
              defaultObj.countryCode = data.countryCode;
            }
            if (data.contactNumber !== undefined) {
              defaultObj.contactNumber = data.contactNumber;
            }
          }
          // Merge: spread data first, then defaultObj so moment-converted date fields take precedence
          const mergedData = { ...data, ...defaultObj };
          form.setFieldsValue(mergedData);
          if (isUsersForm || isDocumitraPartnersForm) {
            setUserFormValues(mergedData);
          }
        }
      }

      if (entityName === APPLICATION_FORM_SERVICES && !isCreateMode) {
        const formTemplateData = formTemplate.filter((item: any) => item.name !== 'password');
        setFormTemplate(formTemplateData);
      }

      if (currentUserRole === 'Accountant') {
        const formTemplateData = formTemplate.filter(
          (item: any) => item.name !== 'status' && item.name !== 'trackingId'
        );

        setFormTemplate(formTemplateData);
      }
    } catch (error) {
      console.error('Error fetching API data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Separate useEffect to handle formDefaultPayload for Header Services
  useEffect(() => {
    if (!props.isCreateMode && entityName === HEADER_SERVICES_ENTITY && props.formDefaultPayload) {
      // Check if formDefaultPayload has serviceName (indicating it's transformed data, not default empty values)
      const hasTransformedData =
        props.formDefaultPayload.serviceName !== undefined ||
        Object.keys(props.formDefaultPayload).some(key => key.startsWith('package'));

      if (hasTransformedData) {
        // Use formDefaultPayload directly for Header Services
        console.log('Header Services: Using formDefaultPayload:', props.formDefaultPayload);
        setIncomingFormData(props.formDefaultPayload);
        setFormDetails(props.formDefaultPayload);
        // Use setTimeout to ensure form is ready, and also try immediately
        form.setFieldsValue(props.formDefaultPayload);
        setTimeout(() => {
          form.setFieldsValue(props.formDefaultPayload);
          console.log('Header Services: Form values set:', props.formDefaultPayload);
        }, 100);
      } else {
        console.log(
          'Header Services: formDefaultPayload does not have transformed data:',
          props.formDefaultPayload
        );
      }
    }
  }, [props.formDefaultPayload, entityName, props.isCreateMode, form]);

  useEffect(() => {
    const validEntityId = props.entityId || props.entityId === '';
    if (!props.isCreateMode && validEntityId) {
      // For Header Services, skip API call if formDefaultPayload is already provided
      if (entityName === HEADER_SERVICES_ENTITY && props.formDefaultPayload) {
        const hasTransformedData =
          props.formDefaultPayload.serviceName !== undefined ||
          Object.keys(props.formDefaultPayload).some(key => key.startsWith('package'));
        if (hasTransformedData) {
          // formDefaultPayload will be handled by the separate useEffect above
          console.log('Skipping API call for Header Services, using formDefaultPayload');
          return;
        }
      }
      getApiData();
    }
  }, [props.isCreateMode, props.entityId]);

  /** To update the datamodel and the selected form values once both additional data and the specific data for this form have been fetched */
  useEffect(() => {
    if (entityName === ORDER_LIST_ENTITY) {
      const availableDeliveryPartners =
        additionalData?.[AVAILABLE_DELIVERY_PARTNERS]?.data?.results;

      if (availableDeliveryPartners) {
        updateDatamodel({
          setFormTemplate,
          incomingFormData,
          availableDeliveryPartners,
          entityId: props.entityId as string,
        });

        updateFormFields({ incomingFormData, form });
      } else {
        if (incomingFormData) {
          const endPointsForDropdownData = [
            {
              name: AVAILABLE_DELIVERY_PARTNERS,
              getAllResponse: true,
              queryParams: { storeId: incomingFormData?.store?.id },
            },
          ];
          setAdditionalEntityName(endPointsForDropdownData);
        }
      }
    }
  }, [additionalData, entityName, form, incomingFormData, props.entityId]);

  const submitForm = (rawPayload: any) => {
    console.log('AbstractForm submitForm - entityName:', entityName);
    console.log('AbstractForm submitForm - rawPayload:', rawPayload);

    /**
     * the payloadProcessor function returns the payload in the format which can be sent in the request. If payloadProcessor function is not passed, then the reduce method is used to process the payload as default
     */

    const payload = props.payloadProcessor
      ? props.payloadProcessor(rawPayload, additionalData, incomingFormData)
      : getOutgoingPayload(
          entityName,
          rawPayload,
          additionalData,
          extraPayloadData,
          incomingFormData,
          nestedEntityName,
          isCreateMode
        );

    console.log('AbstractForm submitForm - processed payload:', payload);

    // Avoid throwing when trackingId is missing (undefined/null) — was blocking all Documitra/Photo saves
    if (
      (entityName === DOCUMITRA_ORDER_APPLICATION || entityName === PHOTO_ORDER_APPLICATION) &&
      (payload.trackingId === undefined ||
        payload.trackingId === null ||
        String(payload.trackingId).trim() === '')
    ) {
      delete payload.trackingId;
    }

    if (entityName === APPLICATION_FORM_PACKAGES && payload.plans) {
      payload.plans = payload.plans.filter(
        (plan: any) => plan !== null && plan !== undefined && plan !== ''
      );
    }

    if (entityName === USERS_ENTITY) {
      const countryCode = payload.createdAt;

      payload.phone = countryCode + '-' + payload.phone;

      delete payload.createdAt;
    }

    // Combine countryCode and contactNumber for Documitra Partners
    // Format: +91-7888154917 (country code with dash separator)
    if (entityName === DOCUMITRA_PARTNERS) {
      if (payload.countryCode && payload.contactNumber) {
        // Ensure country code has + prefix, then combine with dash separator
        // Remove any existing + from country code to avoid double +
        let countryCode = String(payload.countryCode).trim();
        if (!countryCode.startsWith('+')) {
          countryCode = '+' + countryCode;
        }
        // Remove any leading + from phone number if present (shouldn't be, but just in case)
        let phoneNumber = String(payload.contactNumber).trim().replace(/^\+/, '');
        // Combine with dash separator: +91-7888154917
        payload.contactNumber = countryCode + '-' + phoneNumber;
        delete payload.countryCode;
      } else if (payload.countryCode && !payload.contactNumber) {
        // If only country code is provided, still remove it
        delete payload.countryCode;
      }
    }

    // Exclude password field when updating Documitra Partners (password can only be changed by partner themselves)
    if (!isCreateMode && entityName === DOCUMITRA_PARTNERS) {
      delete payload.password;
    }

    // Always exclude confirmPassword for Documitra Partners (not needed)
    if (entityName === DOCUMITRA_PARTNERS) {
      delete payload.confirmPassword;
    }

    if (dynamicValidation === 'country dropdown') {
      payload.options = [
        'India',
        'United States',
        'Canada',
        'United Kingdom',
        'Australia',
        'Germany',
        'France',
        'Japan',
        'Brazil',
        'South Africa',
        'Afghanistan',
        'Albania',
        'Algeria',
        'Andorra',
        'Angola',
        'Antigua and Barbuda',
        'Argentina',
        'Armenia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bhutan',
        'Bolivia',
        'Bosnia and Herzegovina',
        'Botswana',
        'Brunei',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cabo Verde',
        'Cambodia',
        'Cameroon',
        'Central African Republic',
        'Chad',
        'Chile',
        'China',
        'Colombia',
        'Comoros',
        'Congo',
        'Costa Rica',
        'Croatia',
        'Cuba',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican Republic',
        'East Timor (Timor-Leste)',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'Equatorial Guinea',
        'Eritrea',
        'Estonia',
        'Eswatini',
        'Ethiopia',
        'Fiji',
        'Finland',
        'Gabon',
        'Gambia',
        'Georgia',
        'Ghana',
        'Greece',
        'Grenada',
        'Guatemala',
        'Guinea',
        'Guinea-Bissau',
        'Guyana',
        'Haiti',
        'Honduras',
        'Hungary',
        'Iceland',
        'Indonesia',
        'Iran',
        'Iraq',
        'Ireland',
        'Israel',
        'Italy',
        'Jamaica',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kiribati',
        'Korea, North',
        'Korea, South',
        'Kosovo',
        'Kuwait',
        'Kyrgyzstan',
        'Laos',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Marshall Islands',
        'Mauritania',
        'Mauritius',
        'Mexico',
        'Micronesia',
        'Moldova',
        'Monaco',
        'Mongolia',
        'Montenegro',
        'Morocco',
        'Mozambique',
        'Myanmar (Burma)',
        'Namibia',
        'Nauru',
        'Nepal',
        'Netherlands',
        'New Zealand',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'North Macedonia',
        'Norway',
        'Oman',
        'Pakistan',
        'Palau',
        'Palestine State',
        'Panama',
        'Papua New Guinea',
        'Paraguay',
        'Peru',
        'Philippines',
        'Poland',
        'Portugal',
        'Qatar',
        'Romania',
        'Russia',
        'Rwanda',
        'Saint Kitts and Nevis',
        'Saint Lucia',
        'Saint Vincent and the Grenadines',
        'Samoa',
        'San Marino',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Serbia',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'Solomon Islands',
        'Somalia',
        'South Sudan',
        'Spain',
        'Sri Lanka',
        'Sudan',
        'Suriname',
        'Sweden',
        'Switzerland',
        'Syria',
        'Taiwan',
        'Tajikistan',
        'Tanzania',
        'Thailand',
        'Togo',
        'Tonga',
        'Trinidad and Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Tuvalu',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'Uruguay',
        'Uzbekistan',
        'Vanuatu',
        'Vatican City',
        'Venezuela',
        'Vietnam',
        'Yemen',
        'Zambia',
        'Zimbabwe',
      ];
    }

    if (dynamicValidation === 'occupation dropdown') {
      payload.options = [
        'Doctor',
        'Teacher',
        'Software Developer',
        'Nurse',
        'Mechanical Engineer',
        'Graphic Designer',
        'Chef',
        'Police Officer',
        'Journalist',
        'Electrician',
        'Architect',
        'Data Scientist',
        'Librarian',
        'Accountant',
        'Artist',
        'Marketing Manager',
        'Firefighter',
        'Pharmacist',
        'Pilot',
        'Social Worker',
        'Fitness Trainer',
        'Translator',
        'Biologist',
      ];
    }

    if (props.isCreateMode) {
      createEntity(payload, props.entityName);
    } else {
      updateEntity(payload);
    }
  };

  const createEntity = async (payload: any, entityName: string) => {
    setLoading(true);
    console.log(payload);
    try {
      const res: any = await callApi(entityName, 'POST', payload);

      if (res?.status) {
        toastSuccess(`${props.headerName} created successfully!`);
        // Pass the created entity ID if available
        const createdId = res?.data?.data?.id || res?.data?.id;
        props.onSuccessfulUpdate?.('create', createdId);
      } else {
        if (entityName === APPLICATION_FORM_PACKAGES && !payload.plans) {
          toastError('Both Online Consultation and Ready to Ship cannot be empty!!');
        } else {
          // Extract error message from the response
          const errorMessage = res?.data?.message || res?.data?.error || failedMsg;
          toastError(
            `Oops, an error occured! ${props.headerName} creation failed. ${
              res?.data?.message || failedMsg
            }`
          );
        }
      }
    } catch (err: any) {
      // Check if it's an email duplicate error
      if (
        err?.response?.status === 409 ||
        (err?.response?.data?.message && err.response.data.message.toLowerCase().includes('email'))
      ) {
        toastError(
          err?.response?.data?.message ||
            'A partner with this email address already exists. Please use a different email.'
        );
      } else {
        toastError(
          `Oops, an error occured! ${props.headerName} creation failed. ${err?.response?.data?.message || 'Please contact development support team'}`
        );
      }
    }
    setLoading(false);
  };

  const updateEntity = async (payload: any) => {
    setLoading(true);
    const formLabel = props.formHeader ?? props.headerName;

    try {
      const url = props.nestedEntityName || `${props.entityName}/${props.entityId}`;

      const res: any = await callApi(url, updateRequestType, payload);

      if (res?.status) {
        const updatedRecord = res?.data?.data;
        if (updatedRecord) {
          const mapped = getIncomingPayload(props.entityName, updatedRecord);
          setIncomingFormData(updatedRecord);
          setFormDetails(updatedRecord);
          form.setFieldsValue(mapped);
          if (isUsersForm || isDocumitraPartnersForm) {
            setUserFormValues(mapped);
          }
        }

        toastSuccess(`${formLabel} updated successfully!`);

        // Switch back to view mode for partner form after successful update
        if (isDocumitraPartnersForm) {
          setPartnerFormEditing(false);
        }

        props.onSuccessfulUpdate?.(props.entityId);
        props.entityId && props.closeTab?.(props.entityId, true);
      } else {
        // Extract error message from the response
        const errorMessage = res?.data?.message || res?.data?.error || failedMsg;
        toastError(`Oops, an error occurred! ${formLabel} update failed. ${errorMessage}`);
      }
    } catch (err: any) {
      // Check if it's an email duplicate error
      if (
        err?.response?.status === 409 ||
        (err?.response?.data?.message && err.response.data.message.toLowerCase().includes('email'))
      ) {
        toastError(
          err?.response?.data?.message ||
            'A partner with this email address already exists. Please use a different email.'
        );
      } else {
        toastError(
          `Oops, an error occured! ${formLabel} updation failed. ${err?.response?.data?.message || 'Please contact development support team'}`
        );
      }
    }

    setLoading(false);
  };

  const onPublish = () => {
    statusRef.current = 'Published';
    form.submit();
  };

  const onUpdate = () => {
    form.submit();
  };

  const onDelete = async () => {
    setLoading(true);
    const formLabel = props.formHeader ?? props.headerName;

    try {
      const res: any = await callApi(`${props.entityName}/${props.entityId}`, 'DELETE');

      if (res?.status) {
        toastSuccess(`${formLabel} deleted successfully!`);
        props.entityId && props.closeTab?.(props.entityId, true);
      } else {
        toastError(
          `Oops, an error occured! ${formLabel} deletion failed. ${res?.data.message || failedMsg}`
        );
      }
    } catch (err) {
      toastError(
        `Oops, an error occured! ${formLabel} deletion failed. Please contact development support team`
      );
    }

    setLoading(false);
  };

  const handleDeleteClick = () => {
    setOpenModal(true);
  };

  const handleConfirmDelete = async () => {
    await onDelete(); // Perform delete action
    setOpenModal(false);
  };

  const handleCancelDelete = () => {
    setOpenModal(false);
  };

  function getFormElement(formTemplate: InputInterface, i: number) {
    const { fieldType } = formTemplate;

    switch (fieldType.name) {
      case 'checkboxGroup': {
        return <CheckboxGroup formInput={formTemplate} index={i} form={form} />;
      }
      case 'email': {
        return <Email formInput={formTemplate} index={i} />;
      }
      case 'pinCode': {
        return <PinCode formInput={formTemplate} index={i} />;
      }
      case 'number': {
        return <NumberInput formInput={formTemplate} index={i} />;
      }
      case 'select': {
        return (
          <SelectInput
            formInput={formTemplate}
            setFormData={updateRequired && setFormTemplate}
            form={form}
            index={i}
            setDynamicValidation={setDynamicValidation}
            isCreateMode={isCreateMode}
          />
        );
      }
      case 'informationNote': {
        return <InformtionNote />;
      }
      case 'serviceTimeline': {
        return (
          <TimelineTable
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }
      case 'packageProcess': {
        return (
          <PackageProcess
            formInput={formTemplate}
            index={i}
            parentForm={form}
            isCreateMode={isCreateMode}
            additionalData={additionalData}
            formDetails={formDetails}
          />
        );
      }

      case 'dynamicSelect': {
        return (
          <DynamicSelectInput
            formInput={formTemplate}
            setFormData={updateRequired && setFormTemplate}
            form={form}
            index={i}
            isCreateMode={isCreateMode}
          />
        );
      }

      case 'packagePlanSelection': {
        return (
          <PackagePlanSelection
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            packageDetails={formDetails}
          />
        );
      }
      case 'serviceAttributeSelection': {
        return (
          <ServiceAttributeSelection
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            parentForm={form}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }

      case 'refferalUserCard': {
        return (
          <RefferalUserCard
            formInput={formTemplate}
            index={i}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }

      case 'dynamicShowKeys': {
        return (
          <DynamicShowKeys
            formInput={formTemplate}
            setFormData={updateRequired && setFormTemplate}
            form={form}
            index={i}
            isCreateMode={isCreateMode}
          />
        );
      }

      case 'rolePermissions': {
        return (
          <RolePermissions
            formInput={formTemplate}
            setFormData={updateRequired && setFormTemplate}
            form={form}
            index={i}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }
      case 'multiSelect': {
        return (
          <MultiSelectInput
            formInput={formTemplate}
            form={form}
            index={i}
            isCreateMode={isCreateMode}
          />
        );
      }
      case 'optionalSingleSelect': {
        return <OptionalSelectInput formInput={formTemplate} index={i} />;
      }
      case 'timeSlot': {
        return <TimeSlotInput formInput={formTemplate} index={i} />;
      }
      case 'multipleTextInput': {
        return (
          <MultipleTextInput
            formInput={formTemplate}
            form={form}
            entityName={props.nestedEntityName}
            formHeader={props.formHeader}
            setLoading={setLoading}
            index={i}
          />
        );
      }
      case 'textEditor': {
        return <TextEditor formInput={formTemplate} index={i} />;
      }

      // case 'multipleTwinInput': {
      //     return <MultipleTwinInput formInput={formTemplate} index={i} form={form} isCreateMode={isCreateMode} />;
      // }

      case 'reviewDocumitraOrder': {
        return (
          <ReviewDocumitraOrder
            additionalData={{
              ...additionalData,
              onSuccessfulUpdate: props.onSuccessfulUpdate,
              onUpdate: (updated: any) => {
                setFormDetails((prev: any) => (prev ? { ...prev, ...updated } : updated));
                if (updated?.paymentDetails?.paymentStatus != null) {
                  form.setFieldsValue({ paymentStatus: updated.paymentDetails.paymentStatus });
                }
              },
            }}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
            onPrimaryTabChange={setOrderReviewPrimaryTab}
          />
        );
      }
      case 'reviewPhotoOrder': {
        return (
          <ReviewPhotoOrder
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            photoDetails={formDetails}
          />
        );
      }
      case 'reviewPartnerOrder': {
        return (
          <ReviewPartnerOrder
            formInput={formTemplate}
            index={i}
            form={form}
            formDetails={formDetails}
            onPrimaryTabChange={setOrderReviewPrimaryTab}
          />
        );
      }
      case 'reviewPartnerOrderMember': {
        return (
          <ReviewPartnerOrderMember
            formInput={formTemplate}
            index={i}
            form={form}
            formDetails={formDetails}
          />
        );
      }
      case 'formWithQuestions': {
        return (
          <FormWithQuestions
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }
      case 'dynamicCountriesSelect': {
        return (
          <DynamicCountrySelect
            additionalData={additionalData}
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
            formDetails={formDetails}
          />
        );
      }
      case 'MultipleTwinInputforValidation': {
        return (
          <MultipleTwinInputforValidation
            formInput={formTemplate}
            index={i}
            form={form}
            dynamicValidation={dynamicValidation}
          />
        );
      }

      case 'dynamicPackages': {
        return (
          <DynamicPackagesInput
            formInput={formTemplate}
            index={i}
            form={form}
            isCreateMode={isCreateMode}
          />
        );
      }

      case 'checkboxType': {
        return (
          <DynamicCheckboxInput
            formInput={formTemplate}
            index={i}
            dynamicValidation={dynamicValidation}
            formDetails={formDetails}
          />
        );
      }
      case 'radio': {
        return (
          <Form.Item
            name={formTemplate.name}
            label={formTemplate.label}
            wrapperCol={{ span: 8, offset: 4 }}
            labelCol={{ span: 4 }}
            labelAlign="left"
            rules={[
              {
                required: formTemplate.required,
                message: formTemplate.errorMsg,
              },
            ]}
            initialValue={formTemplate.default}
          >
            <Radio.Group
              options={formTemplate.fieldType.options}
              disabled={formTemplate.readonly}
              buttonStyle="solid"
              onChange={e => {
                // Ensure the form value is updated when radio button changes
                form.setFieldsValue({ [formTemplate.name]: e.target.value });
              }}
            />
          </Form.Item>
        );
      }
      case 'booleanCheckbox': {
        return (
          <Form.Item
            name={formTemplate.name}
            valuePropName="checked"
            label={formTemplate.label}
            wrapperCol={{ span: 8, offset: 4 }}
            labelCol={{ span: 4 }}
            labelAlign="left"
            rules={[
              {
                required: formTemplate.required,
                message: formTemplate.errorMsg,
              },
            ]}
          >
            <Checkbox disabled={formTemplate.readonly}>{formTemplate.label}</Checkbox>
          </Form.Item>
        );
      }

      case 'drawerForm': {
        return (
          <DrawerInput
            entityId={props.entityId}
            formInput={formTemplate}
            form={form}
            onSuccessfulUpdate={props.onSuccessfulUpdate}
            isCreateMode={isCreateMode}
          />
        );
      }
      case 'file':
      case 'image':
      case 'video': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }

      case 'documitraFile':
      case 'documitraImage':
      case 'documitraVideo': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }

      case 'aboutPageOurTeamFile':
      case 'aboutPageOurTeamImage':
      case 'aboutPageOurTeamVideo': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }

      case 'photomitraFile':
      case 'photomitraImage':
      case 'photomitraVideo': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }
      case 'photoOrderFile':
      case 'photoOrderImage':
      case 'photoOrderVideo': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }

      case 'newsArticleFile':
      case 'newsArticleImage':
      case 'newsArticleVideo': {
        return <FileInput formInput={formTemplate} index={i} form={form} />;
      }
      case 'date': {
        return <DateInput formInput={formTemplate} index={i} />;
      }

      case 'textarea': {
        return <TextArea formInput={formTemplate} index={i} />;
      }
      case 'phoneWithCountryCode': {
        return (
          <PhoneInput
            formInput={formTemplate}
            index={i}
            form={form}
            additionalData={additionalData}
          />
        );
      }
      default: {
        return <TextInput formInput={formTemplate} index={i} />;
      }
    }
  }

  const allAccordions = getAllAccordions(formTemplate, getFormElement);

  const isUsersForm = entityName === USERS_ENTITY || entityName === ORDER_USER;
  // Only a Super Admin may set another admin user's password (admin users, not customers).
  const canChangeAdminPassword =
    !props.isCreateMode &&
    entityName === USERS_ENTITY &&
    currentUserRole === 'Super Admin' &&
    Boolean(props.entityId);
  const isSignedUpUsersForm = entityName === ORDER_USER;
  const isDocumitraPartnersForm = entityName === DOCUMITRA_PARTNERS;
  const isQueryForm = entityName === CONTACT_FORM || entityName === BECOME_PARTNER_INFO;
  const orderReviewHomeTab =
    entityName === DOCUMITRA_ORDER_APPLICATION
      ? 'user-details'
      : entityName === PARTNER_ORDERS
        ? 'partner-info'
        : null;
  const hideTabScopedOrderButtons =
    !!orderReviewHomeTab &&
    !isCreateMode &&
    orderReviewPrimaryTab != null &&
    orderReviewPrimaryTab !== orderReviewHomeTab;
  const useQueryDetailsCard = isQueryForm && !isCreateMode;
  const useUsersReadonlyCard =
    !isCreateMode && isUsersForm && formTemplate.some(field => field.useReadonlyCard);
  const [usersFormEditing, setUsersFormEditing] = useState(!useUsersReadonlyCard);
  const [partnerFormEditing, setPartnerFormEditing] = useState(!isDocumitraPartnersForm);
  const shouldTrackFormValues = isUsersForm || isDocumitraPartnersForm || isQueryForm;

  const userFormFields = (() => {
    const renderedInline = new Set<string>();
    return formTemplate
      .filter((field: InputInterface) => !field.hideFromAbstractForm && field.isAccordian)
      .map((field: InputInterface, index: number) => {
        const templateIndex = formTemplate.findIndex(
          (item: InputInterface) => item.name === field.name
        );
        const effectiveIdx = templateIndex >= 0 ? templateIndex : index;

        if (renderedInline.has(field.name)) {
          return null;
        }

        const inlineFieldName = (field as any).inlineCountryCodeField;
        if (inlineFieldName) {
          const inlineField = formTemplate.find((f: any) => f.name === inlineFieldName);
          if (inlineField) {
            renderedInline.add(inlineFieldName);
            const inlineIdx = formTemplate.findIndex(
              (item: InputInterface) => item.name === inlineFieldName
            );
            const phoneElement = getFormElement(field, effectiveIdx);
            const countryElement = getFormElement(
              inlineField,
              inlineIdx >= 0 ? inlineIdx : effectiveIdx
            );
            const gridClasses = [
              field.gridSpanFullWidth ? 'users-form-grid--full-width' : '',
              field.hideFromUserFormGrid ||
              (!isCreateMode && !useUsersReadonlyCard && field.sidebarField) ||
              (useUsersReadonlyCard && field.readonly)
                ? 'users-form-grid--hidden'
                : '',
              field.forceGridRowStart ? 'users-form-grid--row-start' : '',
              field.sectionDividerBefore ? 'users-form-grid--section-divider' : '',
            ]
              .filter(Boolean)
              .join(' ');
            const combined = (
              <div
                className="inline-field-group"
                key={field.name}
                style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}
              >
                <div
                  style={{ flex: '0 0 38%', minWidth: 0 }}
                  className="inline-field-group__country"
                >
                  {countryElement}
                </div>
                <div style={{ flex: '1 1 62%', minWidth: 0 }} className="inline-field-group__phone">
                  {phoneElement}
                </div>
              </div>
            );
            if (!gridClasses) return combined;
            return (
              <div className={gridClasses} key={field.name}>
                {combined}
              </div>
            );
          }
        }

        const element = getFormElement(field, effectiveIdx);
        if (isUsersForm && field.name === 'bucket') {
          return (
            <Form.Item
              key={field.name}
              noStyle
              shouldUpdate={(previousValues, currentValues) =>
                previousValues.role !== currentValues.role
              }
            >
              {({ getFieldValue }) =>
                ['Super Admin', 'Accountant', 'Content Manager', 'Content Management'].includes(
                  getFieldValue('role')
                )
                  ? null
                  : element
              }
            </Form.Item>
          );
        }
        const gridClasses = [
          field.gridSpanFullWidth ? 'users-form-grid--full-width' : '',
          field.hideFromUserFormGrid ||
          (!isCreateMode && !useUsersReadonlyCard && field.sidebarField) ||
          (useUsersReadonlyCard && field.readonly)
            ? 'users-form-grid--hidden'
            : '',
          field.forceGridRowStart ? 'users-form-grid--row-start' : '',
          field.sectionDividerBefore ? 'users-form-grid--section-divider' : '',
        ]
          .filter(Boolean)
          .join(' ');
        if (!gridClasses) return element;
        return (
          <div className={gridClasses} key={field.name}>
            {element}
          </div>
        );
      })
      .filter(Boolean);
  })();

  const getUserCountryLabel = (countryCode?: string) => {
    if (!countryCode) return undefined;
    const countryCodeList = additionalData?.[COUNTRY_CODE]?.data;
    const match = countryCodeList?.find(
      (item: { code: string; name: string }) => item.code === countryCode
    );
    return match?.name || countryCode;
  };

  const getUserPhoneDisplay = (countryCode?: string, phone?: string) => {
    if (!phone) return undefined;
    return countryCode ? `${countryCode} ${phone}` : phone;
  };

  const getPartnerCountryLabel = (countryValue?: string) => {
    if (!countryValue) return undefined;
    const countryList = additionalData?.[COUNTRY]?.data;
    if (!countryList) return countryValue;
    const match = countryList.find(
      (item: { code?: string; name?: string; value?: string; label?: string }) =>
        item.code === countryValue ||
        item.value === countryValue ||
        item.name === countryValue ||
        item.label === countryValue
    );
    return match?.name || match?.label || countryValue;
  };

  const getPartnerPhoneDisplay = (values: any) => {
    const phone = values?.contactNumber;
    if (!phone) return undefined;
    return phone;
  };

  const isAdminUser = entityName === USERS_ENTITY;

  const getSignedUpPartnerName = () => {
    const rawRecord = incomingFormData || formDetails || {};
    return (
      rawRecord?.partnerName ||
      rawRecord?.partner?.name ||
      rawRecord?.partnerName ||
      rawRecord?.referredByPartnerName ||
      rawRecord?.affiliate?.name ||
      undefined
    );
  };

  const displayedUserValues =
    Object.keys(userFormValues).length > 0
      ? userFormValues
      : incomingFormData || formDetails || form.getFieldsValue();

  const sidebarValues = isAdminUser
    ? {
        name: displayedUserValues?.name,
        role: displayedUserValues?.role,
        employeeId: displayedUserValues?.employeeId,
        email: displayedUserValues?.email,
        phone: getUserPhoneDisplay(displayedUserValues?.createdAt, displayedUserValues?.phone),
        country: getUserCountryLabel(displayedUserValues?.createdAt),
        isActive:
          displayedUserValues?.isActive === 'Active' ||
          displayedUserValues?.isActive === true ||
          displayedUserValues?.isActive === 'true' ||
          displayedUserValues?.isActive === undefined,
      }
    : isDocumitraPartnersForm
      ? {
          isPartner: true,
          agentId: displayedUserValues?.partnerId,
          name: displayedUserValues?.partnerName || displayedUserValues?.name,
          companyName: displayedUserValues?.companyName,
          country: getPartnerCountryLabel(displayedUserValues?.originCountry),
          contactPerson: displayedUserValues?.contactPerson,
          email: displayedUserValues?.email,
          phone: getPartnerPhoneDisplay(displayedUserValues),
          isActive:
            displayedUserValues?.status === 'Active' ||
            displayedUserValues?.status === true ||
            displayedUserValues?.status === undefined,
        }
      : {
          name: displayedUserValues?.name || displayedUserValues?.userName,
          email: displayedUserValues?.email,
          phone: displayedUserValues?.phone,
          userId: displayedUserValues?.id || displayedUserValues?._id || props.entityId,
          registrationDate: displayedUserValues?.createdAt
            ? moment(displayedUserValues.createdAt).isValid()
              ? moment(displayedUserValues.createdAt).format('DD MMM YYYY')
              : displayedUserValues.createdAt
            : undefined,
          isActive:
            displayedUserValues?.active === 'Active' ||
            displayedUserValues?.active === true ||
            displayedUserValues?.active === 'true' ||
            displayedUserValues?.active === undefined,
          verified:
            displayedUserValues?.isVerified === true ||
            displayedUserValues?.isVerified === 'true' ||
            displayedUserValues?.isVerified === 'True' ||
            displayedUserValues?.isVerified === 'Verified',
          partnerId: displayedUserValues?.partnerId,
          partnerName: getSignedUpPartnerName(),
          hideRegistrationDate: true,
          hideVerificationRow: true,
          hideStatusRow: true,
        };

  const getUserReadonlyValue = (field: InputInterface) => {
    const value =
      form.getFieldValue(field.name) ??
      userFormValues?.[field.name] ??
      incomingFormData?.[field.name] ??
      formDetails?.[field.name];
    if (field.name === 'password') return value ? '********' : '—';
    if (field.name === 'phone') {
      if (!isAdminUser) return value ? String(value) : '—';
      const countryCode = form.getFieldValue('createdAt') ?? userFormValues?.createdAt;
      return value ? getUserPhoneDisplay(countryCode, value) : '—';
    }
    if (field.name === 'createdAt' && isSignedUpUsersForm) {
      const rawDate =
        (value && !Array.isArray(value) ? value : null) ||
        incomingFormData?.createdAt ||
        formDetails?.createdAt;
      if (!rawDate) return '—';
      return moment(rawDate).isValid() ? moment(rawDate).format('DD MMM YYYY') : String(rawDate);
    }
    if (Array.isArray(value)) return value.length ? value.join(', ') : '—';
    if (value && typeof value === 'object') {
      return value.label || value.name || value.value || JSON.stringify(value);
    }
    return value === undefined || value === null || value === '' ? '—' : String(value);
  };

  const getReadonlyIcon = (field: InputInterface) => {
    const name = String(field.name || '').toLowerCase();
    const ftype = String((field as any).fieldType || '').toLowerCase();
    if (/website|url|web|site/.test(name)) return Globe;
    if (/industry|occupation|role|job/.test(name)) return Briefcase;
    if (/city|town/.test(name)) return MapPin;
    if (/state|province|region/.test(name)) return Map;
    if (/country|nation/.test(name)) return Flag;
    if (/zip|postal|pincode|pin(code)?/.test(name)) return Hash;
    if (/email|mail|@/.test(name)) return Mail;
    if (/phone|mobile|contact|telephone/.test(name)) return Phone;
    if (/partner(name)?|name|fullname|username|firstname|lastname/.test(name))
      return /partner/.test(name) ? Users : User;
    if (/date|dob|birthday|created|submitted|at$/.test(name)) return Calendar;
    if (/commission|amount|price|earning|cost|fee|total/.test(name)) return DollarSign;
    if (/percent|discount|rate|tax/.test(name)) return BadgePercent;
    if (/status|verified|active|approval/.test(name)) return BadgeCheck;
    if (/company|companyname|organisation|organization/.test(name)) return Building;
    if (/building|apartment|suite|unit/.test(name)) return Building2;
    if (/street|address|addr|address1|addressline1|address\s*1/.test(name)) return Home;
    if (/addressline2|address2|address\s*2/.test(name)) return Building2;
    if (/id|partnerid|agentid|userid|reference/.test(name)) return CreditCard;
    if (/note|remark|comment|description|detail|instruction/.test(name)) return AlignLeft;
    if (/bank|ifsc|account|swift/.test(name)) return Landmark;
    if (/contactperson|referredby|referral|affiliate/.test(name)) return UserCheck;
    if (/zelle|venmo|upi|payment|paypal|wallet/.test(name)) return CreditCard;
    if (ftype === 'email') return Mail;
    if (ftype === 'phone') return Phone;
    if (ftype === 'date' || ftype === 'datepicker') return Calendar;
    if (ftype === 'number' && /money|price|amount|cost/i.test(field.label || '')) return DollarSign;
    return FileText;
  };

  const userReadonlyFields = formTemplate
    .filter(
      field =>
        !field.hideFromAbstractForm &&
        field.isAccordian &&
        !field.hideFromUserFormGrid &&
        !field.sidebarField &&
        (isSignedUpUsersForm || field.name !== 'createdAt')
    )
    .sort((a, b) => {
      if (!isSignedUpUsersForm) return 0;
      if (a.name === 'createdAt') return -1;
      if (b.name === 'createdAt') return 1;
      return 0;
    });
  const partnerReadonlyFields = formTemplate.filter(
    field =>
      !field.hideFromAbstractForm &&
      field.isAccordian &&
      !field.sidebarField &&
      field.name !== 'createdAt'
  );

  const handleUserFormValuesChange = (_: any, allValues: any) => {
    setUserFormValues(allValues);
  };

  const queryDetailsTitle =
    formTemplate.find((field: InputInterface) => field.title)?.title || 'Details';
  const queryInfoFields = formTemplate.filter(
    (field: InputInterface) =>
      field.isAccordian &&
      !field.hideFromAbstractForm &&
      field.name !== 'message' &&
      field.name !== 'lastStatus'
  );
  const queryMessageField = formTemplate.find((field: InputInterface) => field.name === 'message');
  const queryLastStatusField = formTemplate.find(
    (field: InputInterface) => field.name === 'lastStatus'
  );
  const queryLastStatusOptions = (queryLastStatusField?.fieldType?.options || []).map(
    (option: { label?: string; name?: string; value: string }) => ({
      label: option.label || option.name || option.value,
      value: option.value,
    })
  );

  const getPartnerGridElement = (field: InputInterface, index: number) => {
    const element = getFormElement(field, index);
    const gridClasses = [
      field.forceGridRowStart ? 'users-form-grid--row-start' : '',
      field.sectionDividerBefore ? 'users-form-grid--section-divider' : '',
    ]
      .filter(Boolean)
      .join(' ');

    if (!gridClasses) return element;

    return (
      <div className={gridClasses} key={field.name}>
        {element}
      </div>
    );
  };

  useEffect(() => {
    if (shouldTrackFormValues) {
      setUserFormValues(form.getFieldsValue());
    }
  }, [shouldTrackFormValues, incomingFormData, defaultFormData, form]);

  const getPartnerTabs = () => {
    const filteredFormTemplate = formTemplate.filter(x => !x.hideFromAbstractForm);
    const panels: React.ReactNode[] = [];

    for (let i = 0; i <= filteredFormTemplate.length; i++) {
      if (filteredFormTemplate[i]?.title) {
        const titleField = filteredFormTemplate[i];
        const title = titleField.title!;
        const useSidebarLayout = !!titleField.useSidebarLayoutInAccordion;
        const arr: React.ReactNode[] = [];
        const sidebarArr: React.ReactNode[] = [];

        if (titleField.isAccordian) {
          const idx = formTemplate.findIndex(f => f.name === titleField.name);
          const el = getPartnerGridElement(titleField, idx >= 0 ? idx : i);
          if (titleField.sidebarField) {
            sidebarArr.push(el);
          } else {
            arr.push(el);
          }
        }

        for (
          let j = i + 1;
          j <= filteredFormTemplate.length && !filteredFormTemplate[j]?.title;
          j++
        ) {
          if (filteredFormTemplate[j]?.isAccordian) {
            const field = filteredFormTemplate[j];
            const idx = formTemplate.findIndex(f => f.name === field.name);
            const el = getPartnerGridElement(field, idx >= 0 ? idx : j);
            if (useSidebarLayout && field.sidebarField) {
              sidebarArr.push(el);
            } else {
              arr.push(el);
            }
            i = j;
          }
        }

        if (useSidebarLayout) {
          const usePartnerReadonlyCard =
            !isCreateMode && !!titleField.useReadonlyCard && isDocumitraPartnersForm;
          const formBody = (
            <>
              {sidebarArr.length > 0 && <div style={{ display: 'none' }}>{sidebarArr}</div>}
              {arr}
            </>
          );

          const panelInner = (
            <div
              className="container1"
              style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', padding: '20px' }}
            >
              <UserFormSidebar {...sidebarValues} />
              <div
                className="form-container users-form-main"
                style={{
                  flex: '1 1 500px',
                  minWidth: 0,
                }}
              >
                {usePartnerReadonlyCard ? (
                  <>
                    <div className="users-form-card-header">
                      <h3>{title}</h3>
                      <InvertFillButton
                        onClick={() => {
                          if (partnerFormEditing) {
                            form.submit();
                          } else {
                            setPartnerFormEditing(true);
                          }
                        }}
                        type="button"
                      >
                        {partnerFormEditing ? (
                          'Update'
                        ) : (
                          <span className="button-content">
                            <EditOutlined /> Edit
                          </span>
                        )}
                      </InvertFillButton>
                    </div>
                    {partnerFormEditing ? (
                      <div className="users-form-grid">{formBody}</div>
                    ) : (
                      <div className="users-form-readonly">
                        {partnerReadonlyFields.map(field => {
                          const Icon = getReadonlyIcon(field);
                          const rowClass = [
                            'users-form-readonly__item',
                            field.forceGridRowStart ? 'users-form-readonly__item--row-start' : '',
                            field.sectionDividerBefore
                              ? 'users-form-readonly__item--section-divider'
                              : '',
                          ]
                            .filter(Boolean)
                            .join(' ');
                          return (
                            <div className={rowClass} key={field.name}>
                              <div className="users-form-readonly__label-wrap">
                                <div className="users-form-readonly__icon-box">
                                  <Icon
                                    className="users-form-readonly__icon"
                                    size={18}
                                    strokeWidth={2}
                                  />
                                </div>
                                <span className="users-form-readonly__label">{field.label}</span>
                              </div>
                              <span className="users-form-readonly__value">
                                {getUserReadonlyValue(field)}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="users-form-grid">{formBody}</div>
                )}
              </div>
            </div>
          );

          const panel = (
            <HorizontalTabPanel
              id={title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}
              label={title}
              key={i}
            >
              {panelInner}
            </HorizontalTabPanel>
          );
          panels.push(panel);
        } else {
          const panel = (
            <HorizontalTabPanel
              id={title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}
              label={title}
              key={i}
            >
              {sidebarArr}
              {arr}
            </HorizontalTabPanel>
          );
          panels.push(panel);
        }
      } else {
        if (filteredFormTemplate[i]?.isAccordian) {
          const formElement = getFormElement(filteredFormTemplate[i], i);
          panels.push(
            filteredFormTemplate[i]?.preserveAccordionStyles ? (
              <div className="collapse1" key={i}>
                {formElement}
              </div>
            ) : (
              formElement
            )
          );
        }
      }
    }

    if (props.partnerAdditionalTab) {
      panels.push(
        <HorizontalTabPanel
          id="assigned-services"
          label="Assigned Services"
          key="assigned-services"
        >
          {props.partnerAdditionalTab}
        </HorizontalTabPanel>
      );
    }

    if (props.partnerPaymentLedgerTab) {
      panels.push(
        <HorizontalTabPanel
          id="agent-payment-ledger"
          label="Agent Payment Ledger"
          key="agent-payment-ledger"
        >
          {props.partnerPaymentLedgerTab}
        </HorizontalTabPanel>
      );
    }

    return <HorizontalTabNavigation>{panels}</HorizontalTabNavigation>;
  };

  const renderedAccordions = isDocumitraPartnersForm ? (
    isCreateMode ? (
      <>
        {allAccordions}
        {props.partnerAdditionalTab}
      </>
    ) : (
      getPartnerTabs()
    )
  ) : (
    allAccordions
  );

  return (
    <Spin spinning={loading}>
      <ConfirmationModal
        open={openModal}
        message={`Are you sure you want to delete?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        onClose={handleCancelDelete}
      />
      {canChangeAdminPassword && (
        <AdminPasswordModal
          open={openPasswordModal}
          userId={String(props.entityId)}
          userName={formDetails?.name}
          onClose={() => setOpenPasswordModal(false)}
        />
      )}
      <div
        className={`abstract-form${
          isUsersForm || isDocumitraPartnersForm || useQueryDetailsCard ? ' users-form-layout' : ''
        }`}
      >
        <div className="container1">
          {isUsersForm && <UserFormSidebar {...sidebarValues} />}
          <div
            className={`form-container${isUsersForm || useQueryDetailsCard ? ' users-form-main' : ''}`}
          >
            <Form
              form={form}
              scrollToFirstError={true}
              initialValues={defaultFormData}
              onFinish={submitForm}
              onValuesChange={shouldTrackFormValues ? handleUserFormValuesChange : undefined}
            >
              {isUsersForm ? (
                useUsersReadonlyCard ? (
                  <>
                    <div className="users-form-card-header">
                      <h3>
                        {formTemplate.find((field: InputInterface) => field.title)?.title ||
                          'User Information'}
                      </h3>
                      <div className="users-form-card-header__actions">
                        <InvertFillButton
                          onClick={() => {
                            if (usersFormEditing) {
                              form.submit();
                            } else {
                              setUsersFormEditing(true);
                            }
                          }}
                          type="button"
                        >
                          {usersFormEditing ? (
                            'Update'
                          ) : (
                            <span className="button-content">
                              <EditOutlined /> Edit
                            </span>
                          )}
                        </InvertFillButton>
                        {isSignedUpUsersForm && !hiddenButtons?.delete && (
                          <InvertFillButton
                            variant="red"
                            size="md"
                            fontWeight="semibold"
                            disabled={rolePermission?.delete || props.disabledButton?.delete}
                            onClick={handleDeleteClick}
                            type="button"
                          >
                            Delete
                          </InvertFillButton>
                        )}
                      </div>
                    </div>
                    {usersFormEditing ? (
                      <div className="users-form-grid">{userFormFields}</div>
                    ) : (
                      <div className="users-form-readonly">
                        {userReadonlyFields.map(field => {
                          const Icon = getReadonlyIcon(field);
                          const rowClass = [
                            'users-form-readonly__item',
                            field.forceGridRowStart ? 'users-form-readonly__item--row-start' : '',
                            field.sectionDividerBefore
                              ? 'users-form-readonly__item--section-divider'
                              : '',
                          ]
                            .filter(Boolean)
                            .join(' ');
                          return (
                            <div className={rowClass} key={field.name}>
                              <div className="users-form-readonly__label-wrap">
                                <div className="users-form-readonly__icon-box">
                                  <Icon
                                    className="users-form-readonly__icon"
                                    size={18}
                                    strokeWidth={2}
                                  />
                                </div>
                                <span className="users-form-readonly__label">{field.label}</span>
                              </div>
                              <span className="users-form-readonly__value">
                                {getUserReadonlyValue(field)}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="users-form-grid">{userFormFields}</div>
                )
              ) : useQueryDetailsCard ? (
                <>
                  <div className="query-form-hidden-fields" aria-hidden>
                    {formTemplate
                      .filter(
                        (field: InputInterface) =>
                          field.isAccordian &&
                          !field.hideFromAbstractForm &&
                          field.name !== 'lastStatus'
                      )
                      .map((field: InputInterface, index: number) => {
                        const idx = formTemplate.findIndex(
                          (item: InputInterface) => item.name === field.name
                        );
                        return (
                          <React.Fragment key={field.name}>
                            {getFormElement(field, idx >= 0 ? idx : index)}
                          </React.Fragment>
                        );
                      })}
                  </div>
                  <QueryDetailsCard
                    title={queryDetailsTitle}
                    items={queryInfoFields.map(field => ({
                      name: field.name,
                      label: field.label,
                      value: getUserReadonlyValue(field),
                      icon: getReadonlyIcon(field),
                    }))}
                    messageLabel={queryMessageField?.label}
                    message={queryMessageField ? getUserReadonlyValue(queryMessageField) : '—'}
                    lastStatusLabel={queryLastStatusField?.label || 'Last Status'}
                    lastStatusOptions={queryLastStatusOptions}
                  />
                </>
              ) : (
                renderedAccordions
              )}
            </Form>
            {(isUsersForm || useQueryDetailsCard) &&
              !(useUsersReadonlyCard && isSignedUpUsersForm) && (
                <div className="users-form-actions">
                  {!props.isCreateMode &&
                    !hiddenButtons?.update &&
                    !isAgentUsersPage &&
                    !useUsersReadonlyCard && (
                      <InvertFillButton
                        variant="blue"
                        size="md"
                        fontWeight="semibold"
                        disabled={rolePermission?.update || props.disabledButton?.update}
                        onClick={onUpdate}
                      >
                        Update
                      </InvertFillButton>
                    )}
                  {canChangeAdminPassword && (
                    <InvertFillButton
                      variant="white"
                      size="md"
                      fontWeight="semibold"
                      onClick={() => setOpenPasswordModal(true)}
                    >
                      Change Password
                    </InvertFillButton>
                  )}
                  {!props.isCreateMode &&
                    !hiddenButtons?.delete &&
                    !(useUsersReadonlyCard && isSignedUpUsersForm) && (
                      <InvertFillButton
                        variant="red"
                        size="md"
                        fontWeight="semibold"
                        disabled={rolePermission?.delete || props.disabledButton?.delete}
                        onClick={handleDeleteClick}
                      >
                        Delete
                      </InvertFillButton>
                    )}
                  {props.isCreateMode && !hiddenButtons?.save && (
                    <InvertFillButton
                      variant="blue"
                      size="md"
                      fontWeight="semibold"
                      disabled={rolePermission?.create}
                      onClick={onPublish}
                    >
                      Create
                    </InvertFillButton>
                  )}
                  {!hiddenButtons?.cancel && !isSignedUpUsersForm && (
                    <InvertFillButton
                      variant="white"
                      size="md"
                      fontWeight="semibold"
                      disabled={props.disabledButton?.cancel}
                      onClick={() => {
                        props.closeTab?.(props.entityId || 'a', false);
                      }}
                    >
                      Cancel
                    </InvertFillButton>
                  )}
                  {additionalButtons?.map(button => {
                    const { getOnClickHandler, text, key, isDisabled } = button;
                    return (
                      <button
                        type="button"
                        key={key}
                        className="users-form-btn users-form-btn--update"
                        disabled={isDisabled(incomingFormData)}
                        onClick={getOnClickHandler({
                          entityId: props.entityId,
                          setLoading,
                          onRefresh: getApiData,
                        })}
                      >
                        {text}
                      </button>
                    );
                  })}
                </div>
              )}
          </div>
        </div>

        {!isUsersForm && !useQueryDetailsCard && !hideTabScopedOrderButtons && (
          <div className="btn-container">
            <div className="publish-btn-container">
              <div className="publish-btn">
                {!props.isCreateMode && !hiddenButtons?.update && !isAgentUsersPage && (
                  //Agent user update btn
                  <InvertFillButton
                    variant="blue"
                    size="md"
                    fontWeight="semibold"
                    disabled={rolePermission?.update || props.disabledButton?.update}
                    onClick={onUpdate}
                  >
                    Update
                  </InvertFillButton>
                )}
              </div>
              <div className="publish-btn">
                {!props.isCreateMode && !hiddenButtons?.delete && !hideTabScopedOrderButtons && (
                  <InvertFillButton
                    variant="red"
                    size="md"
                    fontWeight="semibold"
                    disabled={rolePermission?.delete || props.disabledButton?.delete}
                    onClick={handleDeleteClick}
                  >
                    Delete
                  </InvertFillButton>
                )}

                {props.isCreateMode && !hiddenButtons?.save && (
                  <InvertFillButton
                    variant="blue"
                    size="md"
                    fontWeight="semibold"
                    disabled={rolePermission?.create}
                    onClick={onPublish}
                    type="button"
                  >
                    Create
                  </InvertFillButton>
                )}
              </div>
              {!hiddenButtons?.cancel && !hideTabScopedOrderButtons && (
                <div>
                  <InvertFillButton
                    variant="white"
                    size="md"
                    fontWeight="semibold"
                    disabled={props.disabledButton?.cancel}
                    onClick={() => {
                      props.closeTab?.(props.entityId || 'a', false);
                    }}
                  >
                    Cancel
                  </InvertFillButton>
                </div>
              )}
              {additionalButtons?.map(button => {
                const { getOnClickHandler, text, key, isDisabled } = button;
                return (
                  <InvertFillButton
                    variant="blue"
                    size="md"
                    fontWeight="semibold"
                    onClick={getOnClickHandler({
                      entityId: props.entityId,
                      setLoading,
                      onRefresh: getApiData,
                    })}
                    key={key}
                    type="button"
                    style={{
                      opacity: isDisabled(incomingFormData) ? 0.5 : 1,
                      pointerEvents: isDisabled(incomingFormData) ? 'none' : 'auto',
                      cursor: isDisabled(incomingFormData) ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {text}
                  </InvertFillButton>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </Spin>
  );
};

AbstractForm.defaultProps = {
  isCreateMode: true,
  entityId: null,
  formDefaultPayload: {},
  hidePreview: false,
};

export default AbstractForm;
